const initialState = {
    messages: [],
};
const messagesReducer = (
    state: any = initialState,
    action: { type: string, payload?: any },
): any => {
    switch (action.type) {
        case 'MESSAGE_RECEIVED':
            return {
                ...state,
                messages: [...state.messages, action.payload]
            };
        case 'ADD_MESSAGE':
            return {
                ...state,
                messages: [...state.messages, action.payload]
            };
        case 'CLEAR_CHAT':
            return {
                ...state,
                messages: []
            };
        case 'UPDATE_CHAT':
            return {
                ...state,
                ...action.payload
            };
    }
    return state;
};

export default messagesReducer;
